/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReasonRequest
 */
export interface ReasonRequest {
    /**
     * 
     */
    reason: string;
}

/**
 * Check if a given object implements the ReasonRequest interface.
 */
export function instanceOfReasonRequest(value: object): value is ReasonRequest {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function ReasonRequestFromJSON(json: any): ReasonRequest {
    return ReasonRequestFromJSONTyped(json, false);
}

export function ReasonRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReasonRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
    };
}

export function ReasonRequestToJSON(json: any): ReasonRequest {
    return ReasonRequestToJSONTyped(json, false);
}

export function ReasonRequestToJSONTyped(value?: ReasonRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
    };
}

